<template>
  <div>
    <a-card size="small" title="质效看板列表" :loading="loading">
      <a slot="extra" v-has="{ code: 'data:noticeboard:add' }" v-tc="{ name: '创建看板' }" @click="onAdd"> <a-icon type="plus" /> 创建看板 </a>
      <div v-for="(noticeboard, index) in noticeboardList" :key="index">
        <div :class="`${noticeboard.id === current ? 'noticeboard-item noticeboard-item_active' : 'noticeboard-item'}`" @click="onNoticeboard(noticeboard.id)">
          <span class="noticeboard-item_name">{{ noticeboard.title }}</span>
        </div>
      </div>
    </a-card>
    <noticeboard-modal :display="visible" :source-id="noticeboardId" :source-data="noticeboardData" @close="close" />
  </div>
</template>

<script>
import { noticeboardList, noticeboardDelete } from '@/api/data/noticeboard';
import NoticeboardModal from '@/pages/data/components/NoticeboardModal';

export default {
  components: { NoticeboardModal },
  data() {
    return {
      loading: true,
      noticeboardTotal: 0,
      noticeboardList: [],
      current: parseInt(this.$route.query.noticeboardId) || null,
      noticeboardId: null,
      noticeboardData: {},
      visible: false
    };
  },
  watch: {
    current() {
      this.$emit('selected', this.current);
    }
  },
  created() {
    this.getNoticeboardList();
  },
  methods: {
    getNoticeboardList() {
      this.loading = true;
      noticeboardList({})
        .then(res => {
          this.noticeboardList = res.data.items;
          this.total = res.data.total;
          if (this.current === null) {
            this.current = this.noticeboardList[0].id;
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    onDelete(noticeboard_id) {
      const self = this;
      this.$confirm({
        title: '确认',
        content: '确认要删除该看板吗',
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        async onOk() {
          noticeboardDelete({ id: noticeboard_id }).then(() => {
            self.$message.success('删除成功');
            self.getNoticeboardList();
          });
        }
      });
    },

    onNoticeboard(noticeboard_id) {
      this.current = noticeboard_id;
    },

    onAdd() {
      this.visible = true;
    },

    onEdit(noticeboard) {
      this.noticeboardId = noticeboard.id;
      this.noticeboardData = {
        name: noticeboard.name,
        sort: noticeboard.sort
      };
      this.visible = true;
    },

    close(type = 'cancel') {
      this.visible = false;
      this.noticeboardId = null;
      this.noticeboardData = {};
      if (type !== 'cancel') {
        this.getNoticeboardList();
      }
    }
  }
};
</script>

<style lang="less" scoped>
/deep/.ant-card-body {
  padding: 12px 12;
  height: calc(~'100vh - 180px');
}

.noticeboard-item {
  height: 40px;
  line-height: 40px;
  cursor: pointer;
  padding: 0 16px;
  margin: 0 -12px;
}

.noticeboard-item:hover,
.noticeboard-item_active {
  background-color: #e6f7ff;
  color: #1890ff;
}

.noticeboard-item_more {
  float: right;
  font-weight: bold;
}
</style>
